import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class CartRecs extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onAddClick = this.onAddClick.bind(this);

    // privates
    this._inner = this.querySelector('.cart-drawer-recs-inner');
    this._next = this.querySelector('.cart-drawer-recs-controls-next');
    this._prev = this.querySelector('.cart-drawer-recs-controls-prev');
    this._count = this.querySelector('.cart-drawer-recs-controls-count');
    this._add = this.querySelectorAll('.cart-drawer-recs-item-add');

    // instantiate
    this._swiper = new Swiper(this._inner, {
      a11y: true,
      speed: 333,
      loop: false,
      draggable: true,
      autoHeight: false,
      slidesPerView: 'auto',
      watchOverflow: true,
      navigation: {
        nextEl: this._next,
        prevEl: this._prev,
      },
      pagination: {
        el: this._count,
        type: 'fraction',
      },
      keyboard: {
        enabled: false
      },
    });

    // events
    this._add.forEach((btn) => {
      btn.addEventListener('click', this.onAddClick);
    });
  }

  // handle add button click on item
  onAddClick(e) {
    this.addItemAndRefreshCart(e.currentTarget.dataset.id, 1);
  }

  // add an item and refresh cart
  async addItemAndRefreshCart(productId, quantity) {
    try {
      // 1. Add item to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: productId,
            quantity: quantity
          }]
        })
      });

      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();

      const drawer_res = await fetch("/?section_id=cart-drawer");
      const text = await drawer_res.text();
      const html = document.createElement("div");
      html.innerHTML = text;
      const template = html.querySelector(".cart-drawer-box").innerHTML;
      document.querySelector(".cart-drawer-box").innerHTML = template;
      
      document.querySelector('#cart-btn .count').textContent = cartData.item_count;
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }
}
